import { internal, template } from '../../../vendor/elix.js';

function ButtonOutlinedMixin(Base) {

  return class ButtonOutlined extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>
 
              :host {
                --tp-ripple-mixin-background-color: var(--tp-button-outlined-light-mixin-ripple-color);
              }

              #inner {
                color: var(--tp-button-outlined-light-mixin-font-color);
                border: 2px solid var(--tp-button-outlined-light-mixin-border-color);
                background-color: var(--tp-button-outlined-light-background-color);
                line-height: 0;
              }
      
              #inner[disabled], #inner:disabled {
                border: 2px solid var(--tp-button-outlined-light-mixin-border-color-disabled);
                color: var(--tp-button-outlined-light-mixin-font-color-disabled);
                background-color: var(--tp-button-outlined-light-mixin-background-color-disabled);
              }
      
              #inner:hover:enabled,
              #inner:active:enabled,
              :host(:focus) #inner:enabled {
                background-color: var(--tp-button-outlined-light-mixin-background-color-active);
              }
            
            </style>
          `
        );
      }
    }
  }

export default ButtonOutlinedMixin;
